import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PeriodoEjercicioService {

  private periodo_subject = new BehaviorSubject<number | null>(null);

  periodo$ = this.periodo_subject.asObservable();


  private ejercicio_subject = new BehaviorSubject<number | null>(null);

  ejercicio$ = this.ejercicio_subject.asObservable();



  private periodo_object = new BehaviorSubject<any | null>(null);

  periodo_object$ = this.periodo_object.asObservable();


  private ejercicio_object = new BehaviorSubject<any | null>(null);

  ejercicio_object$ = this.ejercicio_object.asObservable();

  constructor() {

    const periodo = localStorage.getItem('periodo_vigente');
    const ejercicio = localStorage.getItem('ejercicio_vigente');

    const ejercicio_object = localStorage.getItem('ejercicio_object_vigente');
    const periodo_object = localStorage.getItem('periodo_object_vigente');
    if (periodo !== null) {
      this.periodo_subject.next(parseInt(periodo));
    }
    if (ejercicio !== null) {
      this.ejercicio_subject.next(parseInt(ejercicio));
    }
    if (ejercicio_object !== null) {
      this.ejercicio_object.next(JSON.parse(ejercicio_object));
    }
    if (periodo_object !== null) {
      this.periodo_object.next(JSON.parse(periodo_object));
    }
  }
  setEjercicio(ejercicio: number) {

    localStorage.setItem('ejercicio_vigente', ejercicio.toString());

    this.ejercicio_subject.next(ejercicio);
  }
  getEjercicioActual(): number | null {
    return this.ejercicio_subject.value;
  }
  setPeriodo(periodo: number) {

    localStorage.setItem('periodo_vigente', periodo.toString());

    this.periodo_subject.next(periodo);

  }

  getPeriodoActual(): number | null {
    return this.periodo_subject.value;
  }
  setPeriodoObject(periodo_object: any) {

    localStorage.setItem('periodo_object_vigente', JSON.stringify(periodo_object));

    this.periodo_object.next(periodo_object);
  }

  getPeriodoObjectActual(): any | null {
    return this.periodo_object.value;
  }

  setEjercicioObject(ejercicio_object: any) {

    localStorage.setItem('ejercicio_object_vigente', JSON.stringify(ejercicio_object));

    this.ejercicio_object.next(ejercicio_object);
  }

  getEjercicioObjectActual(): any | null {
    return this.ejercicio_object.value;
  }

}